import type { Project } from '../data/projectTypes'
import { AGENT_ENTRY_URL } from './docs'
import { isGithubConnected } from './githubTesting'

export const TRACKER_NAMES = { github: 'GitHub Issues', gitlab: 'GitLab Issues', linear: 'Linear', jira: 'Jira', asana: 'Asana' } as const

export function connectedIssueTracker(project: Pick<Project, 'issue_tracker' | 'github'>) {
  const tracker = project.issue_tracker
  if (tracker?.enabled && tracker.apiTokenSet) return {
    name: TRACKER_NAMES[tracker.provider],
    destination: tracker.githubRepoUrl || tracker.gitlabProjectUrl || tracker.linearTeamId || tracker.jiraProjectKey || tracker.asanaProjectUrl,
  }
  if (project.github?.fileIssues && isGithubConnected(project.github)) return { name: TRACKER_NAMES.github, destination: project.github.repoUrl }
  return null
}

export function isCodingAgentConnected(project: Pick<Project, 'agent_connected_at' | 'agent_last_bug_read_at' | 'agent_oldest_unread_bug_at'>, now = Date.now()) {
  if (!project.agent_last_bug_read_at && !project.agent_connected_at) return false
  const unreadAt = project.agent_oldest_unread_bug_at
  return !unreadAt || now - Date.parse(unreadAt) <= 60 * 60 * 1000
}

export function projectAgentPrompt(projectUrl: string) {
  return `Connect to this Replay QA project: ${projectUrl}
Read ${AGENT_ENTRY_URL} and follow its setup instructions. Use an API token I provide to access this existing project, then read its bug list to complete the connection.
Review the reported bugs and their Replay evidence, fix confirmed defects in this codebase, and update each bug's status after fixing it. Keep checking this project's bug list for new reports.`
}
